import { render, staticRenderFns } from "./CollectSummary.vue?vue&type=template&id=752c42e2&scoped=true"
import script from "./CollectSummary.vue?vue&type=script&lang=js"
export * from "./CollectSummary.vue?vue&type=script&lang=js"
import style0 from "./CollectSummary.vue?vue&type=style&index=0&id=752c42e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c42e2",
  null
  
)

export default component.exports